export const IN_APP_SEARCH_QUERY_PARAM_KEY = 'in_app'
export const IN_APP_SEARCH_QUERY_PARAM_VALUE = 'true'
export const IN_APP_STORAGE_KEY = 'in_app'
